import React from 'react'

import { Button, ButtonClean, Loader, Subsection } from '@fourthwall/components'
import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop'

import * as S from './HMAC.styled'
import { HMACDisplay } from './components/HMACDisplay/HMACDisplay'
import { useHMAC } from './hooks/useHMAC'

export const HMAC = () => {
  const { currentShopQuery } = useCurrentShop()
  const { hmac, loading, updateHMAC, updateLoading } = useHMAC()

  return (
    <Subsection title="Embedded HMAC Secret" id="embedded-hmac-secret">
      <S.ContentContainer>
        <div>
          Use this secret to verify HMAC signatures sent to your embedded HMAC iframe.{' '}
          <ButtonClean
            label="Learn more"
            href="https://docs.fourthwall.com/embedded-hmac"
            target="_blank"
            disabled
          />
        </div>
        <S.ActionsContainer>
          {loading || (updateLoading && <Loader />)}
          {!loading && !!hmac?.hmac_secret && <HMACDisplay hmac={hmac.hmac_secret} />}
          {!hmac?.hmac_secret && !updateLoading && (
            <Button
              label="Generate HMAC secret"
              onClick={() => updateHMAC([currentShopQuery.data?.id!!])}
            />
          )}
        </S.ActionsContainer>
      </S.ContentContainer>
    </Subsection>
  )
}
